// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__3l0mz","who":"who__XvwZU"};


//////////////////
// WEBPACK FOOTER
// ./components/who/style.styl
// module id = myCj
// module chunks = 0